const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes in milliseconds

const cache = {
  organisations: new Map(),
  apps: new Map(),
};

export function getCachedOrganisation(organisationId) {
  const cached = cache.organisations.get(organisationId);
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return cached.data;
  }
  return null;
}

export function setCachedOrganisation(organisationId, data) {
  cache.organisations.set(organisationId, {
    data,
    timestamp: Date.now(),
  });
}

export function getCachedApp(organisationId, appId) {
  const key = `${organisationId}-${appId}`;
  const cached = cache.apps.get(key);
  if (cached && Date.now() - cached.timestamp < CACHE_DURATION) {
    return cached.data;
  }
  return null;
}

export function setCachedApp(organisationId, appId, data) {
  const key = `${organisationId}-${appId}`;
  cache.apps.set(key, {
    data,
    timestamp: Date.now(),
  });
}

export function clearCache() {
  cache.organisations.clear();
  cache.apps.clear();
}

// Clear cache when user logs out
window.addEventListener('storage', (event) => {
  if (event.key === 'token' && !event.newValue) {
    clearCache();
  }
}); 